export const getImageAspectRatio = ({
	width,
	height
}: {
	width: number | undefined;
	height: number | undefined;
}) => (width || 1) / (height || 1);
